import {get} from 'common/utils/http';

const root = 'api/v1/bc/';

// eslint-disable-next-line import/prefer-default-export
export const fetchConfigurationFile = ({payload}) =>
  get(`${root}configurationData?template=${payload.template}&resource=${payload.resource}`);
